export default __webpack_public_path__ + "static/noissueTV-701b61118bfd300f5a44cad038caaacd.png";